import React from "react";

export interface DotsLoaderProps {
	classes?: string;
	containerClasses?: string;
}

const DotsLoader: React.FC<DotsLoaderProps> = ({ classes, containerClasses }) => {
	return (
		<span className={containerClasses ?? ""}>
			<div className={`dots-9 ${classes}`}></div>
		</span>
	);
};

export default DotsLoader;
